import { Stack } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

interface CommonIconAvatarProps {
    iconBgColor?: string;
    iconColor?: string;
    icon: string;
    iconSize?: number;
    iconPadding?: number | { xs: number; md: number };
    iconBorderRadius?: number;
    iconWeight?: number | string;
    iconRotate?: string;
    sx?: Record<string, unknown>;
    iconBorder?: string;
}

const CommonIconAvatar: React.FC<CommonIconAvatarProps> = ({
    iconBgColor,
    iconColor,
    icon,
    iconSize = 24,
    iconPadding = 1.25,
    iconBorderRadius = 3,
    iconWeight = 400,
    iconRotate = 'rotate(0deg)',
    sx,
    iconBorder,
}) => {
    return (
        <Stack
            sx={{
                ...sx,
                borderRadius: iconBorderRadius,
                bgcolor: iconBgColor || colors.primaryLight[70],
                p: iconPadding,
                width: 'fit-content',
                alignItems: 'center',
                justifyContent: 'center',
                height: 'fit-content',
                border: iconBorder && `1px solid ${iconBorder || colors.primaryLight[100]}`,
            }}
            className="avatarContainer"
        >
            <span
                className={icon}
                style={{
                    fontSize: iconSize,
                    color: iconColor || colors.fullWhite,
                    fontWeight: iconWeight,
                    transform: iconRotate,
                }}
            />
        </Stack>
    );
};

export default CommonIconAvatar;
